export class IdentityProvidersValidators {
  public static isName(value: string): string | true {
    if (!value) {
      return `Name is required`;
    }

    return true;
  }

  public static isConnectionMethod(value: string): string | true {
    if (!value) {
      return `Connection method is required`;
    }

    return true;
  }
}
